import { createSlice } from '@reduxjs/toolkit'

import { saveWebAdmin } from './thunks/saveWebAdmin'
import { toggleWebAdminStatus } from './thunks/toggleWebAdminStatus'
import { webAdminsAdapter } from './webAdminsAdapters'

export const initialWebAdminState = webAdminsAdapter.getInitialState()

export const webAdminsSlice = createSlice({
  name: 'webAdmins',
  initialState: initialWebAdminState,
  reducers: {
    upsertMultipleWebAdmins: (state, action) => {
      webAdminsAdapter.upsertMany(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveWebAdmin.fulfilled, (state, action) => {
        webAdminsAdapter.upsertOne(state, action.payload)
      })
      .addCase(toggleWebAdminStatus.fulfilled, (state, action) => {
        const id = action.payload

        if (!id) return

        const entity = state.entities[id]

        if (entity) {
          entity.isActive = !entity.isActive
        }
      })
  },
})

export const { upsertMultipleWebAdmins } = webAdminsSlice.actions